import { Injectable } from '@angular/core';
import { isObservable } from 'rxjs';


export type TypeOfResult =
  "string" | "number" | "bigint" | "boolean" | "symbol" | "undefined" | "object" | "function"

export type ReflectedType = "null" | "array" | "date" | "composite" | "unknown" | TypeOfResult

export const SystemKeyRawValue = '$$raw'

@Injectable({
  providedIn: 'root'
})
export class ReflectorService {

  constructor() { }

  isNull(target: any): boolean {
    return target === null
  }

  isUndefined(target: any): boolean {
    return target === undefined
  }

  isNullOrUndefined(target: any): boolean {
    return target === null || target === undefined
  }

  isFunction(target: any): boolean {
    return typeof target === 'function'
  }

  isString(target: any): boolean {
    return typeof target === 'string' || target instanceof String
  }

  isBool(target: any): boolean {
    return typeof target === 'boolean' || target instanceof Boolean
  }

  isNumber(target: any): boolean {
    return typeof target === 'number' || target instanceof Number
  }

  isBigNumber(target: any): boolean {
    return typeof target === 'bigint' || target instanceof BigInt
  }

  isDate(target: any): boolean {
    return Object.prototype.toString.call(target) === '[object Date]'
  }

  isArray(target: any): boolean {
    return Array.isArray(target)
  }

  isObservable(target: any): boolean {
    return isObservable(target)
  }

  isComposite(target: any): boolean {
    return target !== undefined
      && target !== null
      && !Array.isArray(target)
      && !this.isFunction(target)
      && !this.isString(target)
      && !this.isNumber(target)
      && !this.isBigNumber(target)
      && !this.isBool(target)
      && !this.isDate(target)
      && typeof target === 'object'
  }

  isSimple(target: any): boolean {
    return this.isString(target)
      || this.isNumber(target)
      || this.isBigNumber(target)
      || this.isBool(target)
      || this.isDate(target)
  }

  getReflectedType(target: any): ReflectedType {
    if (target === undefined) {
      return 'undefined'
    }
    if (target === null) {
      return 'null'
    }
    if (this.isBool(target)) {
      return 'boolean'
    }
    if (this.isNumber(target)) {
      return 'number'
    }
    if (this.isString(target)) {
      return 'string'
    }
    if (this.isDate(target)) {
      return 'date'
    }
    if (this.isFunction(target)) {
      return 'function'
    }
    if (this.isArray(target)) {
      return 'array'
    }
    if (this.isComposite(target)) {
      return 'composite'
    }
    return 'unknown'
  }
}
